import Vue from 'vue';
import Vuex from 'vuex'
import { Nieuwsbrief } from './Components';
//import store from './Store/store'

Vue.config.productionTip = false;

const app = new Vue({
    el: '#nieuwsbrief-cta',
    //store,
    render: (h) => h(Nieuwsbrief),
});
